import React, { Component } from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
  Button,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from '@material-ui/core';

import './SideBarOptions.css';
import { OptionValues } from './OptionValues';

/*const WODButton = ({label, onChange, allWods, wod}) => {*/
class WODButton extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e){
    const { allWods, onChange, fieldName } = this.props;

    // TODO: pollyfill .closest() for Internet Explorer?
    const button = e.target.closest("button");
    const clickedWodId = button.getAttribute("data-wod-id");

    // TODO: pollyfill Array.findIndex() for IE?
    const wodIndex = allWods.findIndex(wod => wod.id.toString() === clickedWodId);
    const clickedWod = allWods[wodIndex];

    clickedWod[fieldName] = !clickedWod[fieldName];

    // No match found, but this shouldn't happen
    if (wodIndex < 0) {
      return;
    }

    // The original onChange callback from App.js
    onChange({
      option: "selectedWods",
      wods: allWods,
    }, e);
  }

  render() {
    const {label, wod, fieldName} = this.props;

    return (
      <Button
        variant="contained"
        color="primary"
        className="wod-button"
        onClick={this.onClick}
        data-wod-id={wod.id}
        data-field-name={fieldName}
      >
        {label}
      </Button>
    );
  }
}

function WODOptions(props) {
  const {
    label,
    subLabel,
    wods,
    onChange
  } = props;

  const isOdd = wods.length % 2;

  return(
    <div className="option-wrapper">
      <FormLabel className="option-label">{label}</FormLabel>
      <p className="option-sub-label">{subLabel}</p>
      <Grid container justify="center">
        {wods.map((wod, i) => (
          <Grid item key={`wod-${i}`} xs={6} className="wod-wrapper">
            <p className="wod-title">{wod.title}</p>
            <p className="wod-track-name">{wod.track_name}</p>
            <WODButton
              onChange={onChange}
              allWods={wods}
              wod={wod}
              currentWod={wod}
              fieldName="show"
              label={wod.show ? 'Hide Workout' : 'Show Workout'}
            />
            <WODButton
              onChange={onChange}
              allWods={wods}
              wod={wod}
              fieldName="leaderboard"
              label={wod.leaderboard ? 'Hide Leaderboard' : 'Show Leaderboard'}
            />
            {wod.video !== null &&
              <WODButton
                onChange={onChange}
                allWods={wods}
                wod={wod}
                fieldName="video"
                label={wod.video ? 'Hide Video' : 'Show Video'}
              />
            }
          </Grid>
        ))}
        {isOdd &&
          <Grid item key="spacer" xs={6}>
            <div className="hidden">spacer</div>
          </Grid>
        }
      </Grid>
    </div>
  );
}

function SelectOption(props) {
  const {
    label,
    subLabel,
    name,
    value,
    onChange,
  } = props;

  const options = OptionValues[name];
  const labelId = `${name}-label`;

  return(
    <div className="option-wrapper">
      <FormControl>
        <FormLabel className="option-label" id={labelId}>{label}</FormLabel>
        {subLabel &&
          <p className="option-sub-label">{subLabel}</p>
        }
        <Select
          labelId={labelId}
          id={name}
          value={value}
          onChange={(e) => onChange({ option: name }, e)}
          className="option-wrapper-select"
        >
          {options.map((opt, i)=> (
            <MenuItem value={opt.value} key={i}>{opt.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )

}

function RadioOption(props) {
  const {
    label,
    subLabel,
    name,
    value,
    onChange,
  } = props;

  const options = OptionValues[name];

  return (
    <div className="option-wrapper">
      <FormControl component="fieldset">
        <FormLabel className="option-label" component="legend">{label}</FormLabel>
        {subLabel &&
          <p className="option-sub-label">{subLabel}</p>
        }
        <RadioGroup
          aria-label={name}
          name={name}
          value={value}
          onChange={(e) => onChange({ option: name }, e)}
          row
        >
          {options.map((opt, i)=> (
            <FormControlLabel value={opt.value} control={<Radio />} label={opt.label} key={i} />

          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

class SideBarOptions extends Component {
  render() {
    const {
      onChange,
      onClose,
      open,
      availableOptions,
      ...options
    } = this.props;

    if (!availableOptions) {
      return null;
    }

    return(
      <Drawer
        className="drawer"
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: "drawerPaper",
        }}
      >
        <div className="drawerHeader">
            <h3 className="drawerHeader-title">Options</h3>
            <IconButton onClick={onClose}>
              <ChevronLeftIcon />
            </IconButton>
        </div>
        <Divider/>
        <div className="drawerContent">
          {availableOptions.includes("weightUnits") &&
            <RadioOption
              label="Weight Units"
              name="weightUnits"
              value={options.weightUnits.toLowerCase()}
              onChange={onChange}
            />
          }
          {availableOptions.includes("themeColor") &&
            <RadioOption
              label="Theme Color"
              name="themeColor"
              value={options.themeColor.toUpperCase()}
              onChange={onChange}
            />
          }
          {availableOptions.includes("timeToSwitch") &&
            <SelectOption
              label="WOD Display Time (seconds)"
              subLabel="Length of time to display a WOD if rotating between workouts"
              name="timeToSwitch"
              value={options.timeToSwitch.toString()}
              onChange={onChange}
            />
          }
          {availableOptions.includes("scrollSpeed") &&
            <SelectOption
              label="Activity Feed Speed (seconds)"
              subLabel="Speed at which to rotate through the Activity Feed"
              name="scrollSpeed"
              value={options.scrollSpeed.toString()}
              onChange={onChange}
            />
          }
          {availableOptions.includes("distanceNumber") &&
            <SelectOption
              label="Display Size"
              subLabel="Increase or decrease display size for your screen"
              name="distanceNumber"
              value={options.distanceNumber.toString()}
              onChange={onChange}
            />
          }
          {availableOptions.includes("selectedWods") &&
            <WODOptions
              label="Displayed WODs"
              subLabel="Choose up to 4 WODs to display"
              wods={options.selectedWods}
              onChange={onChange}
            />
          }
        </div>
      </Drawer>
    );
  }
}

export default SideBarOptions;